import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="min-h-screen bg-[#f5f4f0]">
      {/* Hero Section - Contained layout with rounded corners */}
      <section className="py-8 px-4 bg-[#f5f4f0]">
        <div className="max-w-7xl mx-auto">
          <div className="relative overflow-hidden rounded-3xl shadow-2xl" style={{ minHeight: '60vh' }}>
            {/* Background image with color grading */}
            <div className="absolute inset-0">
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/swc3m348_arvore.webp"
                alt="Connection with nature"
                className="w-full h-full object-cover ken-burns-zoom"
                style={{
                  filter: 'saturate(0.8) contrast(0.9) sepia(0.1)',
                  objectPosition: '45% center'
                }}
              />
              {/* Gradient overlay - right side for text - reduced opacity */}
              <div className="absolute inset-0 bg-gradient-to-l from-black/30 via-black/15 to-transparent" style={{ width: '55%', marginLeft: 'auto' }}></div>
            </div>

            {/* Content overlay - Text on right, center-aligned */}
            <div className="relative z-10 px-6 md:px-12 py-16 md:py-20">
              {/* Mobile: Centered text */}
              <div className="md:hidden text-center">
                <div className="text-[1.1rem] leading-relaxed text-white mb-6" style={{ fontFamily: 'Cormorant Garamond, serif', textShadow: '2px 2px 8px rgba(0,0,0,0.9)' }}>
                  <p>Motherhood is about more than welcoming a baby into the world.</p>
                </div>
                <div className="text-[1.75rem] leading-tight text-white mb-6" style={{ fontFamily: 'Cormorant Garamond, serif', textShadow: '2px 2px 8px rgba(0,0,0,0.9)' }}>
                  <p>It's also about welcoming a new version of yourself.</p>
                </div>
                <div className="text-[1.1rem] leading-relaxed text-white mb-8" style={{ fontFamily: 'Cormorant Garamond, serif', textShadow: '2px 2px 8px rgba(0,0,0,0.9)' }}>
                  <p>With time, compassion and support, you begin to find your own way.</p>
                </div>
                <p className="text-sm text-white italic" style={{ fontFamily: 'Cormorant Garamond, serif', textShadow: '2px 2px 6px rgba(0,0,0,0.9)' }}>
                  — Cris Soster
                </p>
              </div>

              {/* Desktop: Text on right, center-aligned within that space */}
              <div className="hidden md:flex md:justify-end md:items-center md:min-h-[60vh]">
                <div className="max-w-lg text-center">
                  <div className="text-[1.6rem] leading-relaxed text-white mb-8" style={{ fontFamily: 'Cormorant Garamond, serif', textShadow: '3px 3px 10px rgba(0,0,0,0.95)' }}>
                    <p>Motherhood is about more than welcoming a baby into the world.</p>
                  </div>
                  <div className="text-[2.25rem] leading-tight text-white mb-8" style={{ fontFamily: 'Cormorant Garamond, serif', textShadow: '3px 3px 10px rgba(0,0,0,0.95)' }}>
                    <p>It's also about welcoming a new version of yourself.</p>
                  </div>
                  <div className="text-[1.6rem] leading-relaxed text-white mb-10" style={{ fontFamily: 'Cormorant Garamond, serif', textShadow: '3px 3px 10px rgba(0,0,0,0.95)' }}>
                    <p>With time, compassion and support, you begin to find your own way.</p>
                  </div>
                  <p className="text-[1.6rem] text-white italic" style={{ fontFamily: 'Cormorant Garamond, serif', textShadow: '3px 3px 10px rgba(0,0,0,0.95)' }}>
                    — Cris Soster
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* My Story Section - Box with image on left and scrollable text on right */}
      <section className="py-8 md:py-16 px-4 bg-[#f5f4f0]">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
            <div className="grid md:grid-cols-[1fr_2fr] gap-8 md:gap-12" style={{ maxHeight: 'none' }}>
              {/* Left - Image (Portrait Format) */}
              <div 
                className="overflow-hidden rounded-2xl flex items-center justify-center" 
                style={{ 
                  borderRadius: '1rem',
                  overflow: 'hidden'
                }}
              >
                <img
                  src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/g1bfmll5_Cristiane-160.webp"
                  alt="Family moment"
                  className="w-full h-auto object-contain"
                  style={{ 
                    maxHeight: '70vh',
                    borderRadius: '1rem',
                    display: 'block'
                  }}
                />
              </div>

              {/* Right - Scrollable Text Content */}
              <div className="relative">
                <div className="overflow-y-auto pr-4 max-h-[60vh] md:max-h-[70vh] scrollbar-thin scrollbar-thumb-[#815863] scrollbar-track-[#f5f4f0]">
                  <h2 
                    className="text-3xl md:text-4xl mb-8 sticky top-0 bg-white pt-2 pb-4 z-10 text-center md:text-left" 
                    style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}
                  >
                    How I Found My Way to Soul Bridge
                  </h2>
                  
                  <div 
                    className="space-y-6 leading-relaxed text-lg text-center md:text-left" 
                    style={{ 
                      fontFamily: 'Champagne & Limousines, sans-serif',
                      color: '#815863'
                    }}
                  >
                  <p>I was born in southern Brazil into a family shaped by many histories and many lands. Growing up surrounded by different traditions, foods, beliefs and ways of caring taught me that wisdom is often passed quietly, through generations, relationships and everyday rituals. At the time, I didn't realise that those traditions were planting the seeds of something that would only make sense years later.</p>
                  <p>In 2015, I followed an inner call and moved to London, where I built a new life with my husband and, later, our two children.</p>
                  <p>Motherhood became the turning point.</p>
                  <p>When my first son, Mateus, was born at the birth centre in a beautiful, oxytocin-filled birth, I felt strong, capable and deeply connected. But I was completely unprepared for what came next.</p>
                  <p>No one really talks about how disorienting those first weeks of postpartum can be. The exhaustion. The vulnerability. The profound shift in identity. Breastfeeding brought unexpected challenges, and letting go of how I had imagined feeding my son carried a grief I hadn't anticipated.</p>
                  <p>At the same time, the world shut down. COVID took away any possibility of the village I hadn't yet realised I would need, leaving me to navigate early motherhood in isolation.</p>
                  <p>It was one of the most vulnerable seasons of my life. But somewhere in the silence, the fog and the slow rebuilding, something quietly began to change.</p>
                  <p>I found myself drawn back to the wisdom that has supported women through motherhood for generations. I found myself returning to nature, feeling my feet on the earth, listening to the trees, being near water, and remembering that birth has always been part of life's ancient rhythm.</p>
                  <p>I began to understand that mothers need care as much as the babies they bring into the world. That healing begins with nourishment, rest, gentle rituals and compassionate presence. And that our bodies carry an innate wisdom which, when given the space to be heard, already knows so much.</p>
                  <p>I realised that what women need in this season isn't perfection. It's to feel safe. To feel seen. To be cared for in a way that allows them to trust themselves again.</p>
                  <p>After the birth of my second daughter, Olivia, I chose to train as a doula. Not because I had found all the answers, but because I wanted to become the kind of presence I had once needed myself.</p>
                  <p>Today, Soul Bridge is my way of bringing together compassionate, evidence-informed support with the timeless wisdom that reminds us mothers were never meant to do this alone. My hope is that every woman I support feels seen, cared for and able to trust herself as she finds her own way into motherhood.</p>
                  
                  {/* Signature */}
                  <p className="mt-8 text-2xl pb-4" style={{ fontFamily: 'Satisfy, cursive', fontWeight: 300, color: '#4d6654' }}>
                    Cris xx
                  </p>
                </div>
                </div>
              
                {/* Scroll hint - visible only on mobile */}
                <div className="md:hidden text-center mt-4 text-sm opacity-60 flex items-center justify-center gap-2" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863' }}>
                  <svg className="w-4 h-4 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                  Scroll to read more
                  <svg className="w-4 h-4 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* My Philosophy Section - Two columns with text and image */}
      <section className="py-12 md:py-20 px-4 relative bg-[#f5f4f0]">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-4 md:gap-6 items-center">
            {/* Left - Text content */}
            <div className="text-center md:text-left order-2 md:order-1">
              <h2 className="text-3xl md:text-4xl mb-8" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}>
                What I Believe
              </h2>
              <div className="space-y-6 leading-relaxed text-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863' }}>
                <p>I believe motherhood changes us in ways few experiences can.</p>
                <p>Motherhood is a profound threshold. It invites us into a new relationship with ourselves, asking us to grow, soften and discover strengths we may never have known were there.</p>
                <p>Sometimes old memories, fears and patterns rise to the surface.</p>
                <p>Not because something has gone wrong.</p>
                <p>But because something important is asking to be seen.</p>
              </div>
            </div>

            {/* Right - Image with rounded corners (smaller, full image visible) */}
            <div className="flex justify-center md:justify-end order-1 md:order-2">
              <div className="w-full max-w-[320px] md:max-w-[380px]">
                <img
                  src="https://customer-assets-m6fa6gv7.emergentagent.net/job_ded95140-8b50-4155-82a1-50fd9b34f147/artifacts/hus3ef8w_pink%202.JPG"
                  alt="Peaceful reflection"
                  className="w-full h-auto object-contain rounded-3xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What Guides My Work Section - 4 larger circles horizontally with soft rose color */}
      <section className="py-12 md:py-20 px-4 bg-[#f5f4f0]">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-4xl mb-16 text-center" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}>
            What Guides My Work
          </h2>
          
          {/* 4 larger circles in a horizontal row */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Circle 1 */}
            <div className="flex flex-col items-center">
              <div className="w-80 h-80 rounded-full shadow-lg flex items-center justify-center p-10" style={{ backgroundColor: '#f5e8e8' }}>
                <div className="text-center">
                  <p className="font-semibold text-base mb-3" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863' }}>
                    I believe every woman already carries deep wisdom within herself.
                  </p>
                  <p className="text-sm" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#4d6654' }}>
                    My role isn't to give women the answers. It's to help them hear their own.
                  </p>
                </div>
              </div>
            </div>

            {/* Circle 2 */}
            <div className="flex flex-col items-center">
              <div className="w-80 h-80 rounded-full shadow-lg flex items-center justify-center p-10" style={{ backgroundColor: '#f5e8e8' }}>
                <div className="text-center">
                  <p className="font-semibold text-base mb-3" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863' }}>
                    Healing begins when we feel truly seen.
                  </p>
                  <p className="text-sm" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#4d6654' }}>
                    Sometimes the greatest gift isn't advice. It's being truly witnessed with compassion and without judgement.
                  </p>
                </div>
              </div>
            </div>

            {/* Circle 3 */}
            <div className="flex flex-col items-center">
              <div className="w-80 h-80 rounded-full shadow-lg flex items-center justify-center p-10" style={{ backgroundColor: '#f5e8e8' }}>
                <div className="text-center">
                  <p className="font-semibold text-base mb-3" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863' }}>
                    Motherhood can hold joy and grief at the same time.
                  </p>
                  <p className="text-sm" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#4d6654' }}>
                    Love and overwhelm. Confidence and uncertainty. All of those feelings have a place here.
                  </p>
                </div>
              </div>
            </div>

            {/* Circle 4 */}
            <div className="flex flex-col items-center">
              <div className="w-80 h-80 rounded-full shadow-lg flex items-center justify-center p-10" style={{ backgroundColor: '#f5e8e8' }}>
                <div className="text-center">
                  <p className="font-semibold text-base mb-3" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863' }}>
                    Presence transforms more than perfection ever could.
                  </p>
                  <p className="text-sm" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#4d6654' }}>
                    When women feel seen, supported and safe, they're better able to hear the wisdom that's already within them.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Rooted in both experience and education Section */}
      <section className="py-10 md:py-20 px-4 bg-[#f5f4f0]">
        <div className="max-w-6xl mx-auto bg-white rounded-3xl shadow-lg p-8 md:p-12">
          
          {/* DESKTOP VERSION - Full */}
          <div className="hidden md:block">
            <h2 className="text-3xl md:text-4xl mb-8 text-center" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}>
              Rooted in both experience and education
            </h2>
            <div className="max-w-4xl mx-auto text-gray-600 leading-relaxed text-lg mb-12 text-center" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              <p>Alongside my own experience of motherhood, I've trained professionally as a birth and postpartum doula and continue to deepen my knowledge through ongoing learning, so I can offer care that is both compassionate and evidence-informed.</p>
            </div>
            
            {/* Full Certification Details */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
              <div className="text-center">
                <div className="p-6 rounded-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863', fontSize: '0.875rem', lineHeight: '1.6' }}>
                  <h3 className="font-semibold mb-3" style={{ fontSize: '1.125rem' }}>
                    <a href="https://developingdoulas.co.uk/" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: '#815863' }}>
                      Developing Doulas
                    </a>
                  </h3>
                  <p>Completed Birth & Postnatal course and Postnatal Specialisation.</p>
                </div>
              </div>

              <div className="text-center">
                <div className="p-6 rounded-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863', fontSize: '0.875rem', lineHeight: '1.6' }}>
                  <h3 className="font-semibold mb-3" style={{ fontSize: '1.125rem' }}>
                    <a href="https://www.naoli-vinaver.com/" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: '#815863' }}>
                      Art of Birth
                    </a>
                  </h3>
                  <p>Trained with Naolí Vinaver in traditional and contemporary home birth practices.</p>
                </div>
              </div>

              <div className="text-center">
                <div className="p-6 rounded-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863', fontSize: '0.875rem', lineHeight: '1.6' }}>
                  <h3 className="font-semibold mb-3" style={{ fontSize: '1.125rem', whiteSpace: 'normal' }}>
                    <a href="https://abm.me.uk/" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: '#815863' }}>
                      Association&nbsp;of<br /><span style={{ whiteSpace: 'nowrap' }}>Breastfeeding Mothers</span>
                    </a>
                  </h3>
                  <p>Completed the ABM Peer Supporter Course.</p>
                </div>
              </div>

              <div className="text-center">
                <div className="p-6 rounded-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863', fontSize: '0.875rem', lineHeight: '1.6' }}>
                  <h3 className="font-semibold mb-3" style={{ fontSize: '1.125rem' }}>Paediatric First Aid</h3>
                  <p>Qualified in Paediatric First Aid, with training in first aid care for babies and children.</p>
                </div>
              </div>

              <div className="text-center">
                <div className="p-6 rounded-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863', fontSize: '0.875rem', lineHeight: '1.6' }}>
                  <h3 className="font-semibold mb-3" style={{ fontSize: '1.125rem' }}>Usui Reiki Ryoho</h3>
                  <p>Completed Levels 1, 2 and 3 of Usui Reiki Ryoho.</p>
                </div>
              </div>
            </div>
          </div>

          {/* MOBILE VERSION - Summarized */}
          <div className="block md:hidden">
            <h2 className="text-3xl mb-6 text-center" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}>
              Rooted in experience and education
            </h2>
            <div className="max-w-4xl mx-auto text-gray-600 leading-relaxed text-base mb-8 text-center" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
              <p>Drawing on my own experience of motherhood and professional doula training, I offer compassionate, evidence-informed care.</p>
            </div>
            
            <h3 className="text-xl mb-6 text-center font-semibold" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#4d6654' }}>
              Training & Qualifications
            </h3>
            
            {/* Summarized Certification Details */}
            <div className="space-y-6">
              <div className="text-center">
                <div className="p-4 rounded-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863', fontSize: '0.875rem', lineHeight: '1.6' }}>
                  <h4 className="font-semibold mb-2" style={{ fontSize: '1rem' }}>
                    <a href="https://developingdoulas.co.uk/" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: '#815863' }}>
                      Developing Doulas
                    </a>
                  </h4>
                  <p>Birth & Postnatal Doula Training + Postnatal Specialisation</p>
                </div>
              </div>

              <div className="text-center">
                <div className="p-4 rounded-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863', fontSize: '0.875rem', lineHeight: '1.6' }}>
                  <h4 className="font-semibold mb-2" style={{ fontSize: '1rem' }}>
                    <a href="https://www.naoli-vinaver.com/" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: '#815863' }}>
                      Art of Birth
                    </a>
                  </h4>
                  <p>Training with midwife Naolí Vinaver</p>
                </div>
              </div>

              <div className="text-center">
                <div className="p-4 rounded-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863', fontSize: '0.875rem', lineHeight: '1.6' }}>
                  <h4 className="font-semibold mb-2" style={{ fontSize: '1rem' }}>
                    <a href="https://abm.me.uk/" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: '#815863' }}>
                      Association of Breastfeeding Mothers
                    </a>
                  </h4>
                  <p>ABM Peer Supporter Course</p>
                </div>
              </div>

              <div className="text-center">
                <div className="p-4 rounded-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863', fontSize: '0.875rem', lineHeight: '1.6' }}>
                  <h4 className="font-semibold mb-2" style={{ fontSize: '1rem' }}>Paediatric First Aid</h4>
                  <p>Qualified in Paediatric First Aid</p>
                </div>
              </div>

              <div className="text-center">
                <div className="p-4 rounded-lg" style={{ fontFamily: 'Champagne & Limousines, sans-serif', color: '#815863', fontSize: '0.875rem', lineHeight: '1.6' }}>
                  <h4 className="font-semibold mb-2" style={{ fontSize: '1rem' }}>Usui Reiki Ryoho</h4>
                  <p>Levels 1, 2 & 3 completed</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 px-4 bg-[#f5f4f0]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl mb-8" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#815863' }}>
            Let's begin with a conversation
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed" style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}>
            Whenever you're ready, I'd love to hear from you.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-[#815863] text-white px-10 py-4 rounded-full tracking-wider text-base hover:bg-[#4d6654] transition-all duration-300 hover:scale-110 hover:shadow-xl"
            style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
          >
            BOOK A CONNECTION CALL
          </Link>
        </div>
      </section>

      {/* Back to Top Button - positioned before footer */}
      <div className="py-8 px-4 bg-[#f5f4f0] text-center">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="inline-flex items-center gap-2 text-[#815863] hover:text-[#4d6654] transition-colors duration-300"
          style={{ fontFamily: 'Champagne & Limousines, sans-serif' }}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
          Back to Top
        </button>
      </div>
    </div>
  );
};

export default About;
